import { Box } from '@apia/theme';

export const ToolbarSeparator = () => {
  return <Box className="toolbar__separator">&nbsp;</Box>;
};
